import React, { useState } from "react";
import "./PopupNotif.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

interface PopupNotifProps {
    notif: JSX.Element
}

export default function PopupNotif(props: PopupNotifProps) {

    const [closed, setIsClosed] = useState(true);
    const [permaclosed, setPermaClosed] = useState(false);

    const handleClose = () => {
        setIsClosed(true);
        setPermaClosed(true)
    }

    setTimeout(() => {
        if(!permaclosed) {
            setIsClosed(false)
        }
    }, 2000)

    return (
        <div className={`notif-box ${closed && "closed"}` }>
            {props.notif}
            <div className="close-button-notif">
                <button className="icon-button" onClick={handleClose}><FontAwesomeIcon icon={faXmark}/></button>
            </div>
        </div>
    )
}